import React from 'react';
import { ReactSVG } from 'react-svg';

import UIOptimisationRecommenderRightArrow from '@/assets/img/ui-optimisation-recommender/ui-optimisation-recommender-right-arrow.svg';

import { MINIMISE_CATEGORY_UI_ITEM_PREFIX, MinimiseCategoryUIQuestionItem } from '../NewHotQuestion';

export const MINIMISE_CATEGORY_UI_BUTTON_PREFIX = 'minimise-category-ui-question-button';

const HotQuestionUIOptimisationItem = (
  text: string,
  useUIOptimisationHotQuestion?: boolean,
  minimiseCategoryUIOptions?: {
    isMinimiseCategoryUI?: boolean;
    adhocCategoryName?: string;
    isOtherFrequentlyAsked?: boolean;
  },
) => {
  const { isMinimiseCategoryUI, isOtherFrequentlyAsked, adhocCategoryName } = minimiseCategoryUIOptions || {};

  if (isMinimiseCategoryUI) {
    return {
      className: `${MINIMISE_CATEGORY_UI_ITEM_PREFIX} ${MINIMISE_CATEGORY_UI_BUTTON_PREFIX}`,
      children: (
        <MinimiseCategoryUIQuestionItem
          text={text}
          isOtherFrequentlyAsked={isOtherFrequentlyAsked}
          adhocCategoryName={adhocCategoryName}
        />
      ),
    };
  }

  return useUIOptimisationHotQuestion
    ? {
      children: useUIOptimisationHotQuestion ? (
        <div className="ui-optimisation-hot-question-item">
          <div className="ui-optimisation-hot-question-item-text">{text}</div>
          <ReactSVG src={UIOptimisationRecommenderRightArrow} style={{ width: 12, height: 12, marginLeft: 8 }} />
        </div>
      ) : null,
      className: useUIOptimisationHotQuestion ? 'ui-optimisation-hot-question-item-container' : '',
    }
    : {};
};

export default HotQuestionUIOptimisationItem;
